module.exports = __webpack_public_path__ + "static/media/Building.6ce07df9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Building.svg
// module id = 380
// module chunks = 0